export default "__VITE_ASSET__CK2ySjP3__"